module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<header class="snippet-header"><a href="#" class="snippet-open';
 if ( hasRipple ) { 
__p+=' has-ripple primary-ripple ';
 } 
__p+=' '+
((__t=( iconClass ))==null?'':__t)+
'" ';
 if ( canExpand ) { 
__p+=' data-toggle="expand-spoiler" ';
 } else { 
__p+=' data-click="snippet-open" ';
 } 
__p+=' '+
((__t=( attributes ))==null?'':__t)+
'><span class="snippet-title">'+
((__t=( header ))==null?'':__t)+
'</span> ';
 if ( additionalHeaders.length >=1 ) { 
__p+=' <div class="secondary-snippet-titles"><span class="primary">'+
((__t=(additionalHeaders))==null?'':__t)+
'</span></div> ';
 } 
__p+=' ';
 if ( hasSecondaryTitle ) { 
__p+=' <span class="snippet-title-secondary" aria-hidden="true">'+
((__t=( i18n.tc( "PoppetSnippet", "Updating..." ) ))==null?'':__t)+
'</span> ';
 } 
__p+=' ';
 if ( info.length >= 1 ) { 
__p+=' <dl> ';
 _.each( info, function( dlItem ) { 
__p+=' <dt>'+
((__t=( dlItem.term ))==null?'':__t)+
'</dt><dd>'+
((__t=( dlItem.description ))==null?'':__t)+
'</dd> ';
 }); 
__p+=' </dl> ';
 } 
__p+=' ';
 if ( textRT ) { 
__p+=' <span class="text-rt">'+
((__t=( textRT ))==null?'':__t)+
'</span> ';
 } 
__p+=' </a> ';
 if ( hasBackButton ) { 
__p+=' <button class="back transparent" data-click="button-back" aria-label="'+
((__t=( i18n.tc( "PoppetSnippet", "Back" ) ))==null?'':__t)+
'"><i class="icon icon-material icon-arrow-back" aria-hidden="true"></i></button> ';
 } 
__p+=' ';
 if ( hasDelete ) { 
__p+=' <button class="icon icon-material icon-delete-forever transparent snippet-delete" data-click="snippet-delete"><span class="screen-reader-text">'+
((__t=( i18n.tc( "PoppetSnippet", "Delete" ) ))==null?'':__t)+
'</span></button> ';
 } 
__p+=' </header> ';
 if ( hasContainer ) { 
__p+=' <div data-region="snippet-container" ';
 if ( canExpand ) { 
__p+=' data-container="expand-spoiler" ';
 } 
__p+='></div> ';
 } 
__p+=' ';
}
return __p;
};
